import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function CTASection({
  eyebrow = "Ready to Build?",
  title = "Let's talk about your project.",
  subtitle = "Free, no-obligation quotes. Straight-talking advice. Trusted across Essex & Suffolk.",
}) {
  return (
    <section className="bg-brand-ink text-white py-24 md:py-32" data-testid="cta-section">
      <div className="container-lf">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8 space-y-6">
            <span className="eyebrow text-brand">{eyebrow}</span>
            <h2 className="font-display font-bold uppercase text-5xl md:text-7xl leading-[0.95]">
              {title}
            </h2>
            <p className="text-white/70 text-lg max-w-2xl">{subtitle}</p>
          </div>
          <div className="lg:col-span-4 flex flex-col gap-3">
            <Link to="/contact" data-testid="cta-primary">
              <Button className="w-full rounded-none bg-brand hover:bg-brand-hover text-white h-14 text-base font-semibold uppercase tracking-wider justify-between px-6">
                Request a Quote <ArrowRight className="w-5 h-5" />
              </Button>
            </Link>
            <Link to="/projects" data-testid="cta-secondary">
              <Button
                variant="outline"
                className="w-full rounded-none bg-transparent border-2 border-white text-white hover:bg-white hover:text-brand-ink h-14 text-base font-semibold uppercase tracking-wider justify-between px-6"
              >
                See Our Work <ArrowRight className="w-5 h-5" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
